<template>
  <div class="apps-types-list">
    <div v-if="loading" class="apps-types-list__loading">
      <div class="lds-ring"><div /><div /><div /><div /></div>
    </div>
    <div v-else-if="types.length > 0" class="apps-types-list__grid">
      <AppsTypeCard
        v-for="appType in types"
        :key="appType.type"
        :appType="appType"
        @filter="(val) => emit('filter', val)"
      />
    </div>
    <div v-else-if="!loading" class="apps-types-list__empty">
      No app types available.
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import AppsTypeCard from '@/components/Apps/AppsTypeCard.vue';

const emit = defineEmits(['filter']);

const props = defineProps({
  appsSummary: {
    type: Object,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  searchName: {
    type: String,
    default: '',
  },
  searchTitle: {
    type: String,
    default: '',
  },
  searchAuthor: {
    type: String,
    default: '',
  },
});

const types = computed(() => {
  const allTypes = props.appsSummary?.types ?? [];
  const name = props.searchName.trim().toLowerCase();
  const title = props.searchTitle.trim().toLowerCase();
  const author = props.searchAuthor.trim().toLowerCase();

  return allTypes.filter((t) => {
    if (name && !String(t.type).toLowerCase().includes(name)) return false;
    if (title && !String(t.description ?? '').toLowerCase().includes(title)) return false;
    if (author && !t.authors?.some((a) => String(a).toLowerCase().includes(author))) return false;
    return true;
  });
});
</script>

<style lang="scss" scoped>
.apps-types-list {
  width: 100%;
}

.apps-types-list__loading {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.apps-types-list__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.apps-types-list__empty {
  font-size: 0.85rem;
  padding: 20px 0;
  @include themify() {
    color: #888;
  }
}
</style>
